import { RestClient } from '@pegasus/rest-client';
export var cancelPreliminarySession = function (id) {
    return RestClient.put('/mylounge-api/checkout/cancel-preliminary-session')
        .withClientType('web')
        .acceptStatusCodes([200, 204])
        .withPayload({ id: id })
        .send();
};
export var getLastPreliminaryCheckoutSession = function () {
    return RestClient.get('/api/phoenix/checkout/checkout-sessions/last-preliminary')
        .withClientType('web')
        .acceptStatusCodes([200, 204])
        .send()
        .then(function (res) {
        if (res.status === 204) {
            /**
             * In case of no preliminary checkout session
             * backend returns empty response. Executing `res.json()` function
             * in such a case would throw an error.
             */
            return null;
        }
        return res.json();
    });
};
